import { rem } from 'polished';
import styled from 'styled-components';
import { InterestedBoxStyled } from '../../InterestedBoxStyled';

export const InterestedBoxStyledOV = styled(InterestedBoxStyled)`
    .links-section {
        .section {
            background: ${({ theme }) => theme.colors.grey10};
            border-radius: 0;

            .phone {
                font-size: ${rem(20)};
                color: ${({ theme }) => theme.colors.black2};
                text-decoration: unset;

                svg {
                    width: ${rem(40)};
                    height: ${rem(20)};
                    margin-bottom: -${rem(4)};

                    path {
                        fill: ${({ theme }) => theme.colors.black2} !important;
                    }
                }
            }

            .description2 {
                color: ${({ theme }) => theme.colors.black2};
            }

            button {
                font-weight: ${({ theme }) => theme.fontWeights.textRegular};
                background: ${({ theme }) => theme.colors.grey10};

                &:hover,
                &:focus-visible {
                    background: ${({ theme }) => theme.colors.primary};
                }
            }
        }
    }

    .dealerShare {
        border-bottom: 1px solid transparent;
        cursor: pointer;
        &:hover,
        &:focus-visible {
            border-bottom: 1px solid ${({ theme }) => theme.colors.black2};
        }
    }

    .reinsurance {
        color: ${({ theme }) => theme.colors.black};
        line-height: 1.43;
        font-size: ${rem('14px')};
        border-bottom: 1px solid ${({ theme }) => theme.colors.black};
    }
`;
